export const SEX = {
  MEN: 1,
  WOMEN: 2,
  NULL: 0
}

export const CUSTOMER_ORDER_STATUS = {
  DONE: '订单完成',
  NOTPAY: '未支付',
  PART_PAYMENT: '部分付款',
  WAIT_GROUPS_SUCCESS: '等待拼团成功',
  PAYED: '已支付',
  CANCEL: '已取消',
  WAIT_BUYER_CONFIRM: '待用户收货'
}
